import { Injectable, Injector } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { ConfigurationService } from './configuration.service';
import { IRequestBase } from '../../models/request-base.model';
import { IResponseBase } from '../../models/response-base.model';

import { map } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';

@Injectable()
export class EndpointFactory {

  constructor(protected http: HttpClient, protected configurations: ConfigurationService, private injector: Injector) {

  }

  protected getRequestHeaders(): { headers: HttpHeaders | { [header: string]: string | string[]; } } {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': '*',
    });

    return { headers: headers };
  }

  protected executeRequest<TRequest extends IRequestBase, TResponse extends IResponseBase>(url: string, object: TRequest): Observable<TResponse> {
    {
      let endpointUrl = this.configurations.apiUrl + url;
      return this.http.post(endpointUrl,
        object,
        { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Accept': 'application/json' }), observe: 'response' })
        .pipe(map(response => {
          var output = response.body as TResponse;
          output.headers = response.headers;
          return output;
        }));
    }
  }

  private handleError(error) {
    //need to handle error
    return throwError(error);
  }
}
